export class SearchHTTPError extends Error {
  name = 'SearchHTTPError'
  id: string

  constructor(
    message: string,
    options = {
      id: 'search-http-error',
    }
  ) {
    super(message)
    this.id = options.id
  }
}

export const fetchThrowsIfNotOk: typeof fetch =
  async function fetchThrowsIfNotOk(...args) {
    const response = await fetch(...args)
    if (!response.ok) {
      if (
        response.headers.get('content-type')?.startsWith('application/json')
      ) {
        const error: unknown = await response.json()
        if (
          error &&
          typeof error === 'object' &&
          !Array.isArray(error) &&
          'message' in error &&
          typeof error.message === 'string'
        ) {
          throw new SearchHTTPError(
            error.message,
            'id' in error && typeof error.id === 'string'
              ? { id: error.id }
              : undefined
          )
        }
        throw new Error(JSON.stringify(error))
      }
      const body = await response.text()
      throw new Error(
        `HTTP error! status: ${response.status} ${response.statusText}\n${body}`
      )
    }
    return response
  }
